// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-StudyList-StudyListItem-components-ChangeVoteButton-module__changeVoteButton";
export { _1 as "changeVoteButton" }
